import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addEditDamageInvoice",
  templateUrl: "./addEditDamageInvoice.html",
})
export class AddEditDamageInvoiceComponent {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  invoiceTypeList = ['PROFORMA', 'INVOICE'];
  rateTypeList = ['FLAT RATE','DISCOUNT'];
  invoicedata: any = {
    rate_type:"",
    invoice_type : '',
    corcharge: 0,
    boxless: 0,
    taxper: 5,
    disper: 0,
    salesorder: false,
    rate : 0,
    transport : 0,
    remarks:'',
    narration:''
    
  };
  execApi: boolean = true;
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sale_type = val["sale_type"];
    this.to_sale_type = val["to_sale_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "Convert" || this.mode == "Edit") {
      this.editInvoiceList();
      //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.oncheck(this.invoicedata.salesorder);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.getSalesParty();
    this.getSeason();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.invoicedata.sales_type = this.sale_type;
    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      // this.invoicedata.taxper = 5;
      this.invoicedata.boxless = 0;
      // this.getAutoNumber();
      //this.getAuto();
    }
    if (this.mode == "Convert") {
      this.convertAutoNumber();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#invoice_type").focus();
    }, 100);
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }
  convertAutoNumber() {
    let params = {
      trans_type: this.to_sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };
    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      this.invoicedata.invoiceno = res.auto_no;
    });
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length > 1) {
          if (that.box == "YES") {
            that.invoicedata.boxless -= 10;
          }
          that.data.invoiceList.splice(ind, 1);
          that.calctot();
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.invoiceList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber(type) {
    let params = {
      trans_type: type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };
    this.salesinvservice.getAutoBillNumber(params).then((res: any) => {
      this.invoicedata.invoiceno = res.invoice_no;
    });
  }

  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
      type: "invoice"
    };
    this.salesinvservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.partyCtrl.setValue(this.invoicedata["season"]);
        this.invoicedata.season = res.data.season;
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }

  onSelectInvoiceType(type){
    if(type == 'PROFORMA'){
      this.invoicedata.taxper = 0;
    }else if(type == 'INVOICE'){
      this.invoicedata.taxper = 5;
    }else{
      swal("Please select invoice type");
    }

    this.getAutoNumber(type);
  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  checkBarcode(code) {
    if (code.length == 7) {

      if (this.execApi) {
        this.execApi = false;
      let params = {
        barcode: code,
        invoice_type : 'damage_invoice'
      };
      for (let i = 0; i < this.data.invoiceList.length; i++) {
        code = parseInt(code);
        this.data.invoiceList[i].barcode = parseInt(
          this.data.invoiceList[i].barcode
        );
        if (this.data.invoiceList[i].barcode == code) {
          setTimeout(() => {
            this.invoicedata.barcode = "";
            $("#code").focus();
          }, 500);

          swal({
            title: "Barcode Already Exists",
            timer: 1000,
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.execApi = true;
          return;
        }
      }

      this.salesinvservice.checkBarcode(params).then((res: any) => {
        if (res.data.length == 0) {
          //   swal("Selected Design is invalid!");
          swal({
            title: "Selected Design is invalid",
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000,
          });
          let invalidData = {
            barcode: code,
            type: "invoice",
          };
          this.invalidList.push(invalidData);
          this.invoicedata.barcode = "";
          this.execApi = true;
          return;
        }
        let check_damage = res.data.size.split('');
        let isDamage = true;
        if(check_damage.length > 0){
          if(check_damage[0].toLowerCase() != 'd'){
            isDamage = false;
          }
        }else if(check_damage.length == 0){
          isDamage = false;
        }
        if(!isDamage){
          swal("Please scan damage pcs");
          this.invoicedata.barcode = "";
          this.execApi = true;
          return;
        }
        let row = Object.assign(
          {
            f36: 0,
            f38: 0,
            f40: 0,
            f42: 0,
            f44: 0,
            f46: 0,
            h36: 0,
            h38: 0,
            h40: 0,
            h42: 0,
            h44: 0,
            h46: 0,
          },
          res.data
        );
        row[row.size.substr(1).toLowerCase()] = 1;
        row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
        row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
        row.totqty = row.hqty + row.fqty;
        if(this.invoicedata.rate_type == "FLAT RATE"){
          row.rate = this.invoicedata.rate;
        }
        this.data.invoiceList.push(row);

        var bottom = document.querySelector("#salesTbody");
        setTimeout(() => {
          bottom.scrollTop = bottom.scrollHeight;
        }, 300);

        this.calcBox();
        this.calctot();
        this.execApi = true;
        this.invoicedata.barcode = "";
      });
    }
    }
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    if (this.mode == "Convert" && this.listSelected.length > 0) {
      let listarray = [];
      let selarray = [];
      let that = this;
      listarray = that.data.invoiceList.filter(function (n) {
        return that.listSelected.indexOf(n) > -1 ? false : n;
      });
      let design1 = listarray;
      let desList1 = [];
      for (let i = 0; i < design1.length; i++) {
        if (design1[i].design_no != "") {
          desList1.push(design1[i]);
        }
      }

      selarray = desList1;
      that.data.invoiceList = that.listSelected;
      that.listSelected = selarray;
    }
    let design = this.data.invoiceList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.invoiceList = desList;
    this.onSaveInvoice();
  }

  onSaveInvoice(): void {
    if (
      this.invoicedata.party_name == undefined ||
      this.invoicedata.season == undefined ||
      this.invoicedata.corcharge == null ||
      this.invoicedata.corcharge == undefined
    ) {
      swal("Make sure that the party name or season entered");
    } else {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["boxless"] = this.invoicedata.boxless || 0;
      params["salesorder"] = this.invoicedata.salesorder || false;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      if (this.mode == "Convert") {
        params["estinvoice"] = JSON.stringify(this.listSelected);
      }
      params["del_party_id"] = "";
      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      if (this.invoicedata.mode == "Convert") {
        params["mode"] = "Add";
        params["estimate_dcid"] = this.invoicedata.dcid;
        params["sales_type"] = this.to_sale_type;
      }
      let that = this;

      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.salesinvservice
          .saveUpdateDamageInvoice(params)
          .then(function (res: any) {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
  calcBox() {
    if (this.box == "YES") {
      this.invoicedata.boxless += 10;
    }
  }
  onSelectPartyName(name) {
    let partylist = _.filter(this.partyList, { name: name });
    this.invoicedata.agent_id = partylist[0]["agent_id"];
    this.invoicedata.party_id = partylist[0]["genLedid"];
    this.invoicedata.disper = partylist[0]["discount"];
    this.box = partylist[0]["boxless"];
    this.invoicedata.transport = partylist[0]["transport"];
    $("#seasonn").focus();
  }
  editInvoiceList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dcid: this.invoicedata.dcid,
    };
    this.salesinvservice
      .getSiEntryGridShirtSizeDetDam(params)
      .then((res: any) => {
        this.data.invoiceList = res.data;
        this.calctot();
        var bottom = document.querySelector("#salesTbody");
        bottom.scrollTop = bottom.scrollHeight;
      });
  }
  oncheck(ischeck) {
    if (ischeck == true || ischeck == "true") {
      this.invoicedata.salesorder = true;
    } else {
      this.invoicedata.salesorder = false;
    }
  }

  calctot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      ftot += parseInt(this.data.invoiceList[i]["fqty"]);
      this.invoicedata.ftotal = ftot;
      htot += parseInt(this.data.invoiceList[i]["hqty"]);
      this.invoicedata.htotal = htot;
      tot += parseInt(this.data.invoiceList[i]["totqty"]);
      this.invoicedata.total = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/damageInvoice/addEditDamageInvoice.ts